import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function SignupPage() {
  const nav = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState(null)

  async function submit(e) {
    e.preventDefault()
    setBusy(true); setMsg(null)
    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          emailRedirectTo: `${window.location.origin}/onboarding`,
          data: { display_name: displayName || email.split('@')[0] },
        },
      })
      if (error) throw error
      if (data.session) {
        nav('/onboarding', { replace: true })
      } else {
        setMsg('Check deine E-Mails zum Bestätigen.')
      }
    } catch (e) {
      setMsg(e.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="min-h-screen grid place-items-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4 border border-white/10 rounded-lg p-6 animate-system-open">
        <div className="section-h">Signup</div>

        <input value={displayName} onChange={(e) => setDisplayName(e.target.value)}
               placeholder="Display name (optional)"
               className="w-full bg-transparent border border-white/15 rounded-md px-3 py-2 focus:border-[var(--accent)] outline-none" />

        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
               placeholder="email@you.com"
               className="w-full bg-transparent border border-white/15 rounded-md px-3 py-2 focus:border-[var(--accent)] outline-none" />

        <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
               placeholder="password (min 8)"
               className="w-full bg-transparent border border-white/15 rounded-md px-3 py-2 focus:border-[var(--accent)] outline-none" />

        <button disabled={busy} className="w-full py-2.5 rounded-md bg-[var(--accent)] text-black font-semibold tap disabled:opacity-50">
          {busy ? '…' : 'Create account'}
        </button>

        {msg && <div className="text-xs opacity-80 text-center">{msg}</div>}

        <div className="text-center text-xs opacity-70">
          Schon ein Account? <Link to="/login" className="text-[var(--accent)]">Login</Link>
        </div>
      </form>
    </div>
  )
}
